module.exports = __webpack_public_path__ + "img/small.2101b045.jpg";